import { useEffect, useState, useRef } from "react";

const useOnScreen = <T extends HTMLElement>(
  threshold = 0.1,
  triggerOnce = false
) => {
  const ref = useRef<T | null>(null);
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntersecting(true);
          if (triggerOnce) {
            observer.disconnect();
          }
        } else if (!triggerOnce) {
          setIntersecting(false);
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [threshold, triggerOnce]);

  return { ref, isIntersecting };
};

export default useOnScreen;
